import createURLParams from '@globals/utilities/createURLParams';

/**
 * Pobiera lub wysyła informacje oraz parsuje odpowiedź z JSON-a.
 * @param url - Adres docelowy
 * @param options - obiekt z opcjami przekazywanymi do wywołania fetch
 */
const jsonFetch = async <T>(
	url: string,
	options: Omit<RequestInit, 'body'> & {
		body?: object;
		query?: Record<string, string | number | boolean | undefined>;
	} = {},
): Promise<T> => {
	const { body, query, ...rest } = options;
	const targetOptions: RequestInit = {
		...rest,
		headers: { Accept: 'application/json', ...rest.headers },
	};

	if (body) {
		targetOptions.body = JSON.stringify(options.body);
		targetOptions.headers = {
			'Content-Type': 'application/json',
			...options.headers,
		};
	}

	const search = query ? createURLParams(query).toString() : '';
	const response = await fetch(`${url}${search.length > 0 ? `?${search}` : ''}`, targetOptions);

	if (!response.ok) {
		const contentLength = response.headers.get('Content-Length') || '0';
		const error = contentLength > '0' ? { ...response, data: await response.json() } : response;
		throw error;
	}

	try {
		const res = await response.json();
		return res;
	} catch (error) {
		console.warn(`Response from ${url} was not a valid JSON`);
		return {} as T;
	}
};

export default jsonFetch;
